import { render, staticRenderFns } from "./AIGenerateCreditDisplay.vue?vue&type=template&id=2dda9112&scoped=true&"
import script from "./AIGenerateCreditDisplay.vue?vue&type=script&lang=js&"
export * from "./AIGenerateCreditDisplay.vue?vue&type=script&lang=js&"
import style0 from "./AIGenerateCreditDisplay.vue?vue&type=style&index=0&id=2dda9112&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dda9112",
  null
  
)

export default component.exports